let apiURL = "https://kingshipline-hub-api.herokuapp.com";
if( window.location.hostname === "localhost" )
{
    apiURL = "http://localhost:3001";
}

export default apiURL;